import { APP_LS_NAMESPACE_ID, APPLICANT } from "src/constants";
import { MERCHANTCASHADVANCES, SMALL_BUSINESS_LOAN } from "src/features/LoansHome/Products/constants";
import { SMARTMATCH_TYPE_LOAN_OFFICER, SMARTMATCH_TYPE_UNDER_WRITER, SMARTMATCH_TYPE_LOAN_PROCESSOR, STATUS_APPLICATION_STARTED, STATUS_APPROVED, STATUS_APPROVED_NOT_ACCEPTED, STATUS_CLEAR_TO_CLOSE_COMPLETED, STATUS_DECLINED, STATUS_DOCUMENTS_SIGNED, STATUS_FUNDING, STATUS_INVITATION_SENT, STATUS_LOAN_CLOSED, STATUS_PRE_QUALIFIED, STATUS_SUBMITTED, STATUS_UNDER_REVIEW, STATUS_WITHDRAW } from "src/services/constants";
import { USER_ONBOARD_ADMIN_UNDERWRITER, USER_ONBOARD_ACCOUNTING, USER_ONBOARD_SALES, USER_ONBOARD_ADMIN, USER_ONBOARD_HIGH_CREST, USER_ONBOARD_LOAN_PROCESSOR_READER } from "src/services/constants/accounts";


const mkNonMortgageStages = [
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_SUBMITTED,
                        "display_name": STATUS_SUBMITTED
                    },
                    {
                        "name": STATUS_INVITATION_SENT,
                        "display_name": STATUS_INVITATION_SENT
                    },
                    {
                        "name": STATUS_PRE_QUALIFIED,
                        "display_name": STATUS_PRE_QUALIFIED
                    },
                    {
                        "name": STATUS_APPROVED,
                        "display_name": STATUS_APPROVED
                    },
                    {
                        "name": STATUS_DOCUMENTS_SIGNED,
                        "display_name": STATUS_DOCUMENTS_SIGNED
                    },
                    {
                        "name": STATUS_FUNDING,
                        "display_name": STATUS_FUNDING
                    },
                    {
                        "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
                        "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
                    },
                    {
                        "name": STATUS_LOAN_CLOSED,
                        "display_name": STATUS_LOAN_CLOSED
                    },
                    {
                        "name": STATUS_APPROVED_NOT_ACCEPTED,
                        "display_name": STATUS_APPROVED_NOT_ACCEPTED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    },
                    {
                        "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
                        "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
                    },
                    {
                        "name": STATUS_LOAN_CLOSED,
                        "display_name": STATUS_LOAN_CLOSED
                    }
                ]
            }
        ],
        "name": STATUS_APPLICATION_STARTED,
        "display_name": STATUS_APPLICATION_STARTED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_UNDER_REVIEW,
                        "display_name": STATUS_UNDER_REVIEW
                    },
                    {
                        "name": STATUS_PRE_QUALIFIED,
                        "display_name": STATUS_PRE_QUALIFIED
                    },
                    {
                        "name": STATUS_APPROVED,
                        "display_name": STATUS_APPROVED
                    },
                    {
                        "name": STATUS_DOCUMENTS_SIGNED,
                        "display_name": STATUS_DOCUMENTS_SIGNED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    },
                    {
                        "name": STATUS_LOAN_CLOSED,
                        "display_name": STATUS_LOAN_CLOSED
                    }
                ]
            }
        ],
        "name": STATUS_SUBMITTED,
        "display_name": STATUS_SUBMITTED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_UNDER_REVIEW,
                        "display_name": STATUS_UNDER_REVIEW
                    },
                    {
                        "name": STATUS_PRE_QUALIFIED,
                        "display_name": STATUS_PRE_QUALIFIED
                    },
                    {
                        "name": STATUS_APPROVED,
                        "display_name": STATUS_APPROVED
                    },
                    {
                        "name": STATUS_DOCUMENTS_SIGNED,
                        "display_name": STATUS_DOCUMENTS_SIGNED
                    },
                    {
                        "name": STATUS_FUNDING,
                        "display_name": STATUS_FUNDING
                    },
                    {
                        "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
                        "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
                    },
                    {
                        "name": STATUS_LOAN_CLOSED,
                        "display_name": STATUS_LOAN_CLOSED
                    },
                    {
                        "name": STATUS_APPROVED_NOT_ACCEPTED,
                        "display_name": STATUS_APPROVED_NOT_ACCEPTED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    }
                ]
            }
        ],
        "name": STATUS_INVITATION_SENT,
        "display_name": STATUS_INVITATION_SENT
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_PRE_QUALIFIED,
                        "display_name": STATUS_PRE_QUALIFIED
                    },
                    {
                        "name": STATUS_APPROVED,
                        "display_name": STATUS_APPROVED
                    },
                    {
                        "name": STATUS_DOCUMENTS_SIGNED,
                        "display_name": STATUS_DOCUMENTS_SIGNED
                    },
                    {
                        "name": STATUS_FUNDING,
                        "display_name": STATUS_FUNDING
                    },
                    {
                        "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
                        "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
                    },
                    {
                        "name": STATUS_LOAN_CLOSED,
                        "display_name": STATUS_LOAN_CLOSED
                    },
                    {
                        "name": STATUS_APPROVED_NOT_ACCEPTED,
                        "display_name": STATUS_APPROVED_NOT_ACCEPTED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    }
                ]
            }
        ],
        "name": STATUS_PRE_QUALIFIED,
        "display_name": STATUS_PRE_QUALIFIED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_APPROVED,
                        "display_name": STATUS_APPROVED
                    },
                    {
                        "name": STATUS_DOCUMENTS_SIGNED,
                        "display_name": STATUS_DOCUMENTS_SIGNED
                    },
                    {
                        "name": STATUS_FUNDING,
                        "display_name": STATUS_FUNDING
                    },
                    {
                        "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
                        "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
                    },
                    {
                        "name": STATUS_LOAN_CLOSED,
                        "display_name": STATUS_LOAN_CLOSED
                    },
                    {
                        "name": STATUS_APPROVED_NOT_ACCEPTED,
                        "display_name": STATUS_APPROVED_NOT_ACCEPTED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    }
                ]
            }
        ],
        "name": STATUS_APPROVED,
        "display_name": STATUS_APPROVED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_FUNDING,
                        "display_name": STATUS_FUNDING
                    },
                    {
                        "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
                        "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
                    },
                    {
                        "name": STATUS_LOAN_CLOSED,
                        "display_name": STATUS_LOAN_CLOSED
                    },
                    {
                        "name": STATUS_APPROVED_NOT_ACCEPTED,
                        "display_name": STATUS_APPROVED_NOT_ACCEPTED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    }
                ]
            }
        ],
        "name": STATUS_DOCUMENTS_SIGNED,
        "display_name": STATUS_DOCUMENTS_SIGNED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
                        "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
                    },
                    {
                        "name": STATUS_LOAN_CLOSED,
                        "display_name": STATUS_LOAN_CLOSED
                    },
                    {
                        "name": STATUS_APPROVED_NOT_ACCEPTED,
                        "display_name": STATUS_APPROVED_NOT_ACCEPTED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    }
                ]
            }
        ],
        "name": STATUS_FUNDING,
        "display_name": STATUS_FUNDING
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_APPROVED_NOT_ACCEPTED,
                        "display_name": STATUS_APPROVED_NOT_ACCEPTED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    }
                ]
            }
        ],
        "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
        "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    }
                ]
            }
        ],
        "name": STATUS_LOAN_CLOSED,
        "display_name": STATUS_LOAN_CLOSED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_SUBMITTED,
                        "display_name": STATUS_SUBMITTED
                    }
                ]
            }
        ],
        "name": STATUS_APPROVED_NOT_ACCEPTED,
        "display_name": STATUS_APPROVED_NOT_ACCEPTED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_SUBMITTED,
                        "display_name": STATUS_SUBMITTED
                    }
                ]
            }
        ],
        "name": STATUS_WITHDRAW,
        "display_name": STATUS_WITHDRAW
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_SUBMITTED,
                        "display_name": STATUS_SUBMITTED
                    }
                ]
            }
        ],
        "name": STATUS_DECLINED,
        "display_name": STATUS_DECLINED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    }
                ]
            }
        ],
        "name": STATUS_LOAN_CLOSED,
        "display_name": STATUS_LOAN_CLOSED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_UNDER_REVIEW,
                        "display_name": STATUS_UNDER_REVIEW
                    },
                    {
                        "name": STATUS_PRE_QUALIFIED,
                        "display_name": STATUS_PRE_QUALIFIED
                    },
                    {
                        "name": STATUS_APPROVED,
                        "display_name": STATUS_APPROVED
                    },
                    {
                        "name": STATUS_DOCUMENTS_SIGNED,
                        "display_name": STATUS_DOCUMENTS_SIGNED
                    },
                    {
                        "name": STATUS_FUNDING,
                        "display_name": STATUS_FUNDING
                    },
                    {
                        "name": STATUS_CLEAR_TO_CLOSE_COMPLETED,
                        "display_name": STATUS_CLEAR_TO_CLOSE_COMPLETED
                    },
                    {
                        "name": STATUS_LOAN_CLOSED,
                        "display_name": STATUS_LOAN_CLOSED
                    },
                    {
                        "name": STATUS_APPROVED_NOT_ACCEPTED,
                        "display_name": STATUS_APPROVED_NOT_ACCEPTED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    }
                ]
            }
        ],
        "name": STATUS_UNDER_REVIEW,
        "display_name": STATUS_UNDER_REVIEW
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_SUBMITTED,
                        "display_name": STATUS_SUBMITTED
                    }
                ]
            }
        ],
        "name": STATUS_APPROVED_NOT_ACCEPTED,
        "display_name": STATUS_APPROVED_NOT_ACCEPTED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_SUBMITTED,
                        "display_name": STATUS_SUBMITTED
                    }
                ]
            }
        ],
        "name": STATUS_WITHDRAW,
        "display_name": STATUS_WITHDRAW
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_DECLINED,
                        "display_name": STATUS_DECLINED
                    },
                    {
                        "name": STATUS_WITHDRAW,
                        "display_name": STATUS_WITHDRAW
                    },
                    {
                        "name": STATUS_SUBMITTED,
                        "display_name": STATUS_SUBMITTED
                    }
                ]
            }
        ],
        "name": STATUS_DECLINED,
        "display_name": STATUS_DECLINED
    }
]

const mkNonMortgageApplicantStages = [
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_SUBMITTED,
                        "display_name": STATUS_SUBMITTED
                    }
                ]
            }
        ],
        "name": STATUS_APPLICATION_STARTED,
        "display_name": STATUS_APPLICATION_STARTED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_UNDER_REVIEW,
                        "display_name": STATUS_UNDER_REVIEW
                    }
                ]
            }
        ],
        "name": STATUS_SUBMITTED,
        "display_name": STATUS_SUBMITTED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_PRE_QUALIFIED,
                        "display_name": STATUS_PRE_QUALIFIED
                    }
                ]
            }
        ],
        "name": STATUS_UNDER_REVIEW,
        "display_name": STATUS_UNDER_REVIEW
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_APPROVED,
                        "display_name": STATUS_APPROVED
                    }
                ]
            }
        ],
        "name": STATUS_PRE_QUALIFIED,
        "display_name": STATUS_PRE_QUALIFIED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_DOCUMENTS_SIGNED,
                        "display_name": STATUS_DOCUMENTS_SIGNED
                    }
                ]
            }
        ],
        "name": STATUS_APPROVED,
        "display_name": STATUS_APPROVED
    },
    {
        "children": [
            {
                "stages": [
                    {
                        "name": STATUS_FUNDING,
                        "display_name": STATUS_FUNDING
                    },
                    {
                        "name": STATUS_LOAN_CLOSED,
                        "display_name": STATUS_LOAN_CLOSED
                    }
                ]
            }
        ],
        "name": STATUS_DOCUMENTS_SIGNED,
        "display_name": STATUS_DOCUMENTS_SIGNED
    },
    {
        "children": [
            {
                "stages": []
            }
        ],
        "name": STATUS_FUNDING,
        "display_name": STATUS_FUNDING
    },
    {
        "children": [
            {
                "stages": []
            }
        ],
        "name": STATUS_LOAN_CLOSED,
        "display_name": STATUS_LOAN_CLOSED
    }
]

const APPLS_APPLICANT_LOAN_STAGES_CONFIG = {
    id: '154878745215745754',
    namespace_id: APP_LS_NAMESPACE_ID,
    loan_type: [MERCHANTCASHADVANCES],
    sub_loan_types: [SMALL_BUSINESS_LOAN],
    stages: mkNonMortgageApplicantStages,
    roles: [APPLICANT],
};


const APPLS_MCA_LOAN_STAGES_CONFIG = {
    id: '154878745215745754',
    namespace_id: APP_LS_NAMESPACE_ID,
    loan_type: [MERCHANTCASHADVANCES],
    stages: mkNonMortgageStages,
    sub_loan_types: [SMALL_BUSINESS_LOAN],
    roles: [
        SMARTMATCH_TYPE_LOAN_OFFICER,
        SMARTMATCH_TYPE_UNDER_WRITER,
        USER_ONBOARD_ADMIN_UNDERWRITER,
        USER_ONBOARD_ACCOUNTING,
        SMARTMATCH_TYPE_LOAN_OFFICER,
        SMARTMATCH_TYPE_LOAN_PROCESSOR,
        USER_ONBOARD_SALES,
        USER_ONBOARD_ADMIN,
        USER_ONBOARD_HIGH_CREST,
        USER_ONBOARD_LOAN_PROCESSOR_READER,
    ],
};

export const fundaloanStages = [
    APPLS_APPLICANT_LOAN_STAGES_CONFIG,
    APPLS_MCA_LOAN_STAGES_CONFIG
]